import * as React from 'react';
import { documentService } from '@services/DocumentService';
import { DocumentViewModel, FileViewModel } from '@models/Document';
import { ModalProps, Spinner } from '@common/components';
import { FileUpload, FileRemove } from '@common/components/file-upload';
import * as classes from '@common/components/file-list/file-list.scss';
import { dateParser } from '@common/dateParser';

export interface FileListProps {
  readonly fileList: DocumentViewModel[];
  readonly isModal: boolean;
  readonly uploadCallback: (fileVMs: FileViewModel[]) => void;
  readonly removeCallback: (fileId: number) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly uploadModalTitle: string;
  readonly removeModalTitle: string;
  readonly forContract: boolean;
  readonly isLoading: boolean;
  readonly canRemove?: boolean;
}

export class FileListComponent extends React.Component<FileListProps> {
  private readonly apiRoot: string;
  constructor(props: FileListProps) {
    super(props);
    this.apiRoot = documentService.getRootPath();
  }

  showFileUploadModal = () => {
    this.props.toggleModal({
      title: this.props.uploadModalTitle,
      component: FileUpload,
      saveCallback: this.loadFile.bind(this),
      saveLabel: 'Save File',
      childProps: { forContract: this.props.forContract }
    });
  };

  loadFile(fileVMs: FileViewModel[]) {
    this.props.toggleModal();
    this.props.uploadCallback(fileVMs);
  }

  showFileRemoveModal = (fileId: number, filename: string) => {
    this.props.toggleModal({
      title: this.props.removeModalTitle,
      component: FileRemove,
      saveLabel: 'Remove File',
      saveCallback: this.removeFile.bind(this),
      childProps: { fileId: fileId, filename: filename }
    });
  };

  removeFile(fileId: number) {
    this.props.toggleModal();
    this.props.removeCallback(fileId);
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="row center-xs middle-xs">
          <Spinner />
        </div>
      );
    }
    return (
      <>
        <h2>
          Files
          <span className="ml-10 pl-10">
            <a href="javascript:void(0);" onClick={this.showFileUploadModal}>
              Upload Files
            </a>
          </span>
        </h2>
        <div className={classes.contactContainer}>
          <div className="row p-10">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <label>Uploaded files: </label>
                  <div className="col-md-12 vertical-scroll h-150">
                    {this.props.fileList &&
                      this.props.fileList.length > 0 &&
                      this.props.fileList.map((d, index) => {
                        return (
                          <div key={d.id} className="row m-0 mt-5 dark-gray-bc">
                            <div className="col-md-11">
                              <div>
                                <a href={this.apiRoot + '/' + d.id + '/download'} download={d.fileName}>
                                  {d.fileName}
                                </a>
                              </div>
                              <div>
                                <label>Created: </label>
                                <span>
                                  {d.createdDate ? dateParser.parse(d.createdDate).format('MM/DD/YYYY') : '--/--/----'}
                                </span>
                              </div>
                              {this.props.forContract && (
                                <div>
                                  <label>Type: </label>
                                  <span>{d.edocsType ? d.edocsType.value : '-----'}</span>
                                </div>
                              )}
                            </div>
                            {this.props.canRemove && (
                              <div className="col-md-1 text-right">
                                <span>
                                  <i
                                    className="fa fa-times"
                                    onClick={() => {
                                      this.showFileRemoveModal(d.id, d.fileName);
                                    }}
                                  />
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/file-list/_components/file-list.component.tsx